import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { CCUFSA_EVENT } from '@/data/events';

export const EventsHero = () => (
  <section className="relative pt-28 pb-16 md:pt-36 md:pb-24 overflow-hidden">
    <div className="absolute inset-0 bg-grain opacity-60 pointer-events-none" />
    <div className="absolute -top-32 -left-32 h-[28rem] w-[28rem] rounded-full bg-leaf-soft/40 blur-3xl pointer-events-none" />
    <div className="absolute top-20 -right-32 h-[26rem] w-[26rem] rounded-full bg-honey-soft/50 blur-3xl pointer-events-none" />

    <div className="container mx-auto relative">
      <div className="text-sm text-muted-foreground flex items-center gap-2">
        <Link to="/" className="hover:text-primary">Home</Link>
        <ChevronRight className="h-3.5 w-3.5" />
        <span className="text-primary font-medium">Events</span>
      </div>
      <div className="grid lg:grid-cols-12 gap-10 mt-8 items-end">
        <div className="lg:col-span-8">
          <div className="font-script text-2xl text-leaf">where we'll be next</div>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-primary font-medium leading-[1.02] mt-2 text-balance">
            Come find the<br/>
            <span className="italic font-light text-leaf">warm-from-oven tray.</span>
          </h1>
          <p className="mt-6 text-base md:text-lg text-muted-foreground max-w-2xl text-pretty">
            We pack the proofer and hit the road. From Ottawa to Vancouver, the
            VDBF team brings frozen-to-oven samples, sell sheets and a friendly conversation
            about your next plant-based breakfast program.
          </p>
        </div>
        <div className="lg:col-span-4">
          <div className="rounded-2xl bg-card border border-border/70 p-5 shadow-soft">
            <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground">Up next</div>
            <div className="font-display text-xl font-semibold text-primary mt-1">CCUFSA 2026 · Ottawa</div>
            <div className="text-sm text-muted-foreground mt-1">{CCUFSA_EVENT.date}</div>
            <Button asChild className="w-full mt-4 rounded-full bg-primary text-primary-foreground hover:bg-primary/90">
              <a href="#ccufsa">Jump to conference details <ChevronRight className="ml-1 h-4 w-4" /></a>
            </Button>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default EventsHero;
